import React from 'react'

export default function CrifSection({ crifData, crifDecisionData, handleDownload }) {
    return (
        <>

            {/* {
            Object.keys(crifDecisionData)?.length > 0 ?
         <div className="row from-group text-center" style={{ marginTop: '40px' }}>
                                    <div className="col-xs-12">
                                        <div style={{}}>
                                            <table className='phocket-table' >
                                                <thead style={{ position: 'sticky', top: "0" }}>
                                                    <tr>
                                                        <td>CRIF Score</td>
                                                        <td>CRIF Decision</td>
                                                        <td>BRE Score</td>
                                                        <td>BRE Decision</td>
                                                        

                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    <tr>
                                                        <td>{crifDecisionData?.crifScore || "-"}</td>
                                                        <td>{crifDecisionData?.crifDecision || "-"}</td>
                                                        <td>{crifDecisionData?.breScore || "-"}</td>
                                                        <td>{crifDecisionData?.breDecision || "-"}</td>
                                                       
                                                    </tr>

                                                </tbody>
                                            </table>

                                        </div>
                                    </div>

                                </div>
        :''} */}
            {
                crifData ?
                    <>

                        <div style={{ marginTop: '40px', height: '330px', overflowY: 'auto', marginTop: '30px' }}>
                            <div
                                id="crifReportcontent"
                                dangerouslySetInnerHTML={{
                                    __html: crifData
                                }}
                            ></div>
                        </div>
                    </>
                    :
                    <p className='' style={{ color: 'red', textAlign: 'center' }}>No Data Found</p>
            }
        </>
    )
}
